export default {
    name: 'status',
    state: {
        status: [
            {
                id: 0,
                label: 'Waiting',
                value: 'waiting'
            },
            {
                id: 1,
                label: 'Delivered',
                value: 'delivered'
            }, {
                id: 2,
                label: 'Approved',
                value: 'approved'
            }, {
                id: 3,
                label: 'On Process',
                value: 'on process'
            }, {
                id: 4,
                label: 'Revised',
                value: 'revised'
            }, {
                id: 5,
                label: 'Rejected',
                value: 'rejected'
            }
            , {
                id: 6,
                label: 'Verified',
                value: 'verified'
            }, {
                id: 7,
                label: 'Transferred',
                value: 'transferred'
            }, {
                id: 8,
                label: 'Closed',
                value: 'closed'
            },
        ],
        statusPp: [
            {
                id: 1,
                label: 'On Process',
                value: 'on process'
            },
            {
                id: 2,
                label: 'Verified',
                value: 'verified'
            },
            {
                id: 3,
                label: 'Revised',
                value: 'revised'
            },
            {
                id: 6,
                label: 'Cancelled',
                value: 'cancelled'
            },
            {
                id: 7,
                label: 'Closed',
                value: 'closed'
            },
            {
                id: 4,
                label: 'Rejected',
                value: 'rejected'
            }

        ],
        statusKlaimPD: [
            {
                id: 0,
                label: 'Waiting',
                value: 'waiting'
            },
            {
                id: 1,
                label: 'On Process',
                value: 'on process'
            },
            {
                id: 2,
                label: 'Transferred',
                value: 'transferred'
            },
            {
                id: 3,
                label: 'Revised',
                value: 'revised'
            },
            {
                id: 4,
                label: 'Rejected',
                value: 'rejected'
            },
            {
                id: 5,
                label: 'Verified',
                value: 'verified'
            },
            {
                id: 6,
                label: 'Cancelled',
                value: 'cancelled'
            },
            {
                id: 7,
                label: 'Closed',
                value: 'closed'
            },
            {
                id: 8,
                label: 'Approved',
                value: 'approved'
            },
            {
                id: 9,
                label: 'Delivered',
                value: 'delivered'
            },
        ],
        statusLapUMPD: [
            {
                id: 0,
                label: 'Waiting',
                value: 'waiting'
            },
            {
                id: 1,
                label: 'On Process',
                value: 'on process'
            },
            {
                id: 2,
                label: 'Verified',
                value: 'verified'
            },
            {
                id: 3,
                label: 'Revised',
                value: 'revised'
            },
            {
                id: 4,
                label: 'Approved',
                value: 'approved'
            },
            {
                id: 5,
                label: 'Rejected',
                value: 'rejected'
            },
            {
                id: 6,
                label: 'Transferred',
                value: 'transferred'
            },
            {
                id: 7,
                label: 'Closed',
                value: 'Closed'
            },
            {
                id: 8,
                label: 'Delivered',
                value: 'delivered'
            },
        ],
        statusWO: [
            {
                id: 1,
                label: 'Delivered',
                value: 'delivered'
            }, {
                id: 2,
                label: 'Approved',
                value: 'approved'
            }, {
                id: 3,
                label: 'On Process',
                value: 'on process'
            }, {
                id: 4,
                label: 'Revised',
                value: 'revised'
            }, {
                id: 5,
                label: 'Rejected',
                value: 'rejected'
            }
            , {
                id: 6,
                label: 'Verified',
                value: 'verified'
            },
            {
                id: 7,
                label: 'Transferred',
                value: 'Transferred'
            },
            {
                id: 8,
                label: 'Closed',
                value: 'Closed'
            },
        ],
        statusShipmentPo: [
            {
                id: 1,
                label: 'Delivered',
                value: 'Delivered'
            },
            {
                id: 2,
                label: 'Received',
                value: 'Received'
            },

        ],
        statusPi:[
            {
                text: "Technic item/service purchasing",
                value: "1"
            },
            {
                text: "Non technic item/service purchasing",
                value: "2"
            },
            {
                text: "Payment instruction",
                value: "3"
            },
            {
                text: "Commission",
                value: "4"
            },
            {
                text: "Other",
                value: "5"
            }
        ],
    },
    getters: {
        getStatus: state => {
            return state.status
        },
        getStatusPp: state => {
            return state.statusPp
        },
        getStatusKlaimPD: state => {
            return state.statusKlaimPD
        },
        getStatusLapUMPD: state => {
            return state.statusLapUMPD
        },
        getStatusWO: state => {
            return state.statusWO
        },
        getStatusShipment: state => {
            return state.statusShipmentPo
        },
        getCategoryPI: state => {
            return state.statusPi
        },
    }
}